import React, {
    useEffect,
  } from "react";
  
  import {
    createPortal,
  } from "react-dom";
  
  import {
    FaCheck,
    FaLayerGroup,
    FaPlus,
    FaTimes,
  } from "react-icons/fa";
  
  import {
    useTranslation,
  } from "react-i18next";
  
  import "../styles/PendentLoadAcceptModal.css";
  
  const formatMeters = (
    value
  ) => {
    const number =
      Number(
        value
      );
  
    if (
      !Number.isFinite(
        number
      )
    ) {
      return "—";
    }
  
    return `${number.toFixed(2)} m`;
  };
  
  export default function PendentLoadAcceptModal({
    isOpen,
    load,
    sessions = [],
    loading = false,
    error = "",
    selectedChoice,
    isSubmitting = false,
    onSelectChoice,
    onClose,
    onConfirm,
  }) {
    const {
      t,
    } =
      useTranslation(
        "pendent_loads"
      );
  
    useEffect(
      () => {
        if (!isOpen) {
          return undefined;
        }
  
        const previousOverflow =
          document.body.style.overflow;
  
        document.body.style.overflow =
          "hidden";
  
        const handleKeyDown =
          (
            event
          ) => {
            if (
              event.key ===
                "Escape" &&
              !isSubmitting
            ) {
              onClose?.();
            }
          };
  
        window.addEventListener(
          "keydown",
          handleKeyDown
        );
  
        return () => {
          document.body.style.overflow =
            previousOverflow;
  
          window.removeEventListener(
            "keydown",
            handleKeyDown
          );
        };
      },
      [
        isOpen,
        isSubmitting,
        onClose,
      ]
    );
  
    if (
      !isOpen ||
      typeof document ===
        "undefined"
    ) {
      return null;
    }
  
    const isNewSelected =
      selectedChoice?.mode ===
      "new";
  
    return createPortal(
      <div
        className="pendent-accept-modal-backdrop"
        onMouseDown={
          (
            event
          ) => {
            if (
              event.target ===
                event.currentTarget &&
              !isSubmitting
            ) {
              onClose?.();
            }
          }
        }
      >
        <section
          className="pendent-accept-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="pendent-accept-modal-title"
        >
          <header className="pendent-accept-modal__header">
            <div className="pendent-accept-modal__heading">
              <div className="pendent-accept-modal__icon">
                <FaLayerGroup />
              </div>
  
              <div>
                <h2 id="pendent-accept-modal-title">
                  {t(
                    "acceptModal.title",
                    "Aceitar carga"
                  )}
                </h2>
  
                <p>
                  {t(
                    "acceptModal.subtitle",
                    "Escolhe em que Transport Session queres colocar esta carga."
                  )}
                </p>
              </div>
            </div>
  
            <button
              type="button"
              className="pendent-accept-modal__close"
              onClick={onClose}
              disabled={isSubmitting}
            >
              <FaTimes />
            </button>
          </header>
  
          <div className="pendent-accept-modal__summary">
            <strong>
              Pendent Load #
              {load?.pendentLoadNumber ??
                load?.id ??
                "—"}
            </strong>
  
            <span>
              {formatMeters(
                load?.length
              )}
            </span>
  
            <span>
              {load?.pickupLocation ||
                "—"}{" "}
              →{" "}
              {load?.deliveryLocation ||
                "—"}
            </span>
          </div>
  
          <div className="pendent-accept-modal__body">
            <button
              type="button"
              className={[
                "pendent-accept-option",
                isNewSelected
                  ? "is-selected"
                  : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={
                () =>
                  onSelectChoice?.({
                    mode: "new",
                    transportsessionId: null,
                  })
              }
            >
              <span className="pendent-accept-option__radio">
                {isNewSelected && (
                  <FaCheck />
                )}
              </span>
  
              <span className="pendent-accept-option__content">
                <strong>
                  <FaPlus />
  
                  {t(
                    "acceptModal.createNew",
                    "Criar nova Transport Session"
                  )}
                </strong>
  
                <small>
                  {t(
                    "acceptModal.createNewDescription",
                    "A carga ficará numa Transport Session nova."
                  )}
                </small>
              </span>
            </button>
  
            <div className="pendent-accept-modal__divider">
              {t(
                "acceptModal.orExisting",
                "ou adicionar a uma Transport Session ativa"
              )}
            </div>
  
            {loading ? (
              <div className="pendent-accept-modal__empty">
                A carregar Transport Sessions...
              </div>
            ) : error ? (
              <div className="pendent-accept-modal__error">
                {error}
              </div>
            ) : sessions.length === 0 ? (
              <div className="pendent-accept-modal__empty">
                Não existem Transport Sessions ativas.
              </div>
            ) : (
              <div className="pendent-accept-modal__sessions">
                {sessions.map(
                  (
                    session
                  ) => {
                    const isSelected =
                      selectedChoice?.mode ===
                        "existing" &&
                      Number(
                        selectedChoice?.transportsessionId
                      ) ===
                        Number(
                          session.id
                        );
  
                    return (
                      <button
                        key={session.id}
                        type="button"
                        disabled={
                          !session.canFit ||
                          isSubmitting
                        }
                        className={[
                          "pendent-accept-option",
  
                          isSelected
                            ? "is-selected"
                            : "",
  
                          !session.canFit
                            ? "is-disabled"
                            : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                        onClick={
                          () =>
                            onSelectChoice?.({
                              mode:
                                "existing",
  
                              transportsessionId:
                                session.id,
                            })
                        }
                      >
                        <span className="pendent-accept-option__radio">
                          {isSelected && (
                            <FaCheck />
                          )}
                        </span>
  
                        <span className="pendent-accept-option__content">
                          <span className="pendent-accept-option__top">
                            <strong>
                              Transport Session #
                              {session.transportSessionNumber ??
                                session.id}
                            </strong>
  
                            <em
                              className={
                                session.canFit
                                  ? "available"
                                  : "full"
                              }
                            >
                              {session.canFit
                                ? "Disponível"
                                : "Sem espaço"}
                            </em>
                          </span>
  
                          <small>
                            {session.loadCount} carga(s)
                            {" · "}
                            Usado:{" "}
                            {formatMeters(
                              session.usedLength
                            )}
                            {" · "}
                            Livre:{" "}
                            {formatMeters(
                              session.remainingLength
                            )}
                          </small>
  
                          {session.canFit && (
                            <small>
                              Depois desta carga:{" "}
                              {formatMeters(
                                session.remainingAfterAcceptance
                              )}{" "}
                              livres
                            </small>
                          )}
                        </span>
                      </button>
                    );
                  }
                )}
              </div>
            )}
          </div>
  
          <footer className="pendent-accept-modal__footer">
            <button
              type="button"
              className="pendent-accept-modal__cancel"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancelar
            </button>
  
            <button
              type="button"
              className="pendent-accept-modal__confirm"
              onClick={onConfirm}
              disabled={
                !selectedChoice ||
                isSubmitting
              }
            >
              {isSubmitting
                ? "A aceitar..."
                : "Aceitar carga"}
            </button>
          </footer>
        </section>
      </div>,
      document.body
    );
  }